export const UserRoles = {
  SUPER_ADMIN: 'super-admin',
  FRIENDS_FAMILY: 'friends-family',
  SUPPORT: 'support',
  CREATOR: 'creator',
} as const;

export type UserRole = typeof UserRoles[keyof typeof UserRoles];

export const ValidUserRoles: UserRole[] = Object.values(UserRoles);
